import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, RunIdSchema } from "../primitives/ids.js";
import { EnreinArtifactUriSchema } from "./artifact-uri.js";
export const ArtifactTruthV1Schema = z
    .object({
    schemaVersion: z.literal("artifact-truth.v1.0"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    runId: RunIdSchema,
    artifactUri: EnreinArtifactUriSchema,
    committedAt: z.string().datetime(),
    artifactSetHash: z.string().min(1),
    clientSafe: z.boolean(),
})
    .strict();
//# sourceMappingURL=artifact-truth.js.map